import React, {useState, useEffect} from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography } from '@material-ui/core';

import {useSelector} from 'react-redux';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1)
  }
}));


const Profile = props => {
  const { className, tempSetUser, ...rest } = props;

  const classes = useStyles();

  const admin_name = useSelector((store) => store.user.admin_name);

  const user = {
    // name: 'beak san',
    // name: props.user.u_name ,
    avatar: '/images/avatars/avatar_default2.png',
    // bio: 'Brain Director',
    // bio: props.user.u_group || '로그아웃 상태',
  };

  const [userState, setUserState] = useState({
    // name: props.user.admin_name || '로그아웃 상태',
    name: admin_name || '로그아웃 상태',
    avatar: '/images/avatars/avatar_default2.png',
    // bio: props.user.admin_id || '로그아웃 상태',
    // bio: props.user.group || '로그아웃 상태',
  });





  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Avatar
        alt="Person"
        className={classes.avatar}
        component={RouterLink}
        src={user.avatar}
        to="/account"
        variant='square'
      />
      <Typography
        className={classes.name}
        variant="h4"
      >
        {admin_name}
      </Typography>
      {/* <Typography variant="body2">{userState.name}</Typography> */}
    </div>
  );
};


Profile.propTypes = {
  className: PropTypes.string
};



export default Profile;
